export const PUPPET_FORGE = 'https://forgeapi.puppet.com';
